import React from 'react';
import type { UnionToIntersection } from '../../../../models/utilityTypes';
import { GetInternalLinkFunctionType } from '../../../../models/GetInternalLinkFunctionType';
import { SanityBlockBuilderLinkGrid } from '../../../../models/gatsby-graphql-types';
import BlockBuilderLinkGridCard from './BlockBuilderLinkGridCard';

export type BlockBuilderLinkGridProps = {
  value: SanityBlockBuilderLinkGrid;
  getInternalLink: GetInternalLinkFunctionType;
};
function BlockBuilderLinkGrid({
  value: { items },
  getInternalLink,
}: Readonly<BlockBuilderLinkGridProps>) {
  if (!items?.length || items.length === 0) {
    return null;
  }

  return (
    <ul
      className={`list-none grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-8 lg:grid-cols-3 xl:gap-8 ${
        items.length === 3 ? 'xl:grid-cols-3' : 'xl:grid-cols-4'
      }`}
    >
      {items.map((item, i) => (
        <li key={item.id || i} className="flex w-full justify-stretch">
          <BlockBuilderLinkGridCard
            // Item can take on many block types, we caste to allow TS to understand that the fields may be undefined
            item={
              item as UnionToIntersection<
                SanityBlockBuilderLinkGrid['items'][number]
              >
            }
            getInternalLink={getInternalLink}
          />
        </li>
      ))}
    </ul>
  );
}

export default BlockBuilderLinkGrid;
